import { forwardRef, type InputHTMLAttributes } from 'react';
import { Checkbox as AntCheckbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> & {
  onChange?: (e: { target: { checked: boolean; value?: string } }) => void;
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ onChange, checked, defaultChecked, disabled, id, className, value, ...rest }, ref) => {
    void rest;
    return (
      <AntCheckbox
        ref={ref as never}
        id={id}
        className={className}
        checked={checked as boolean | undefined}
        defaultChecked={defaultChecked as boolean | undefined}
        disabled={disabled}
        onChange={(e: CheckboxChangeEvent) =>
          onChange?.({ target: { checked: e.target.checked, value: value as string | undefined } })
        }
      />
    );
  },
);
Checkbox.displayName = 'Checkbox';
